import { Autocomplete, Button, DateRange, Field, Filter, SearchField } from "components/commons";
import { useRouter } from "hooks";
import { locale } from "localization/en";
import styles from "./discount-report-filter.module.scss";

const DiscountReportFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  exportReport,
  exporting,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const { replace, pathname, query } = useRouter();
  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={() => {
            if (query?.shiftId) {
              replace(pathname);
            } else {
              applyClearFilter?.();
            }
          }}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            label={locale.arrangeBy}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="orderBy"
              value={filterState.orderBy}
              options={[
                {
                  label: locale.date,
                  value: "processedAt",
                },
                {
                  label: locale.discount,
                  value: "discount",
                },
                {
                  label: locale.salesInvoiceNo,
                  value: "receiptNumber",
                },
              ]}
              onChange={(name, { value }) => {
                modifyFilter({ [name]: value });
              }}
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            placeholder={[locale.productDescription, locale.salesInvoiceNo, locale.discount].join(
              ", ",
            )}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={() => {
              applyClearSearch?.();
              if (query?.shiftId || query?.promoName) {
                replace(pathname);
              }
            }}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={exportReport}
            disabled={exporting}
            loading={exporting}
          >
            {locale.export}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default DiscountReportFilter;
